export default __webpack_public_path__ + "static/media/bg-min.715e5991.png";